'use strict';

var chunkJHFKSNYO_js = require('./chunk-JHFKSNYO.js');

/**
*        
*   ---=== FlexTools ===---
*   https://zhangfisher.github.com/flex-tools
* 
*   一些实用工具函数
*
*/
function e(r){return r?!!(Array.isArray(r)||r instanceof Set||r instanceof Map||chunkJHFKSNYO_js.a(r)):!1}

exports.a = e;
